export { default } from "./MsPricingV2Mspa";
